var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from 'react';
//@ts-ignore
import { AiOutlineLoading } from 'react-icons/ai';
import { FaPlus } from 'react-icons/fa';
import { useLanguage } from '@base/LanguageProvider';
import { DocumentType, WidgetType } from '@common/api';
import DashGrid from '@main/dashboard/DashGrid';
import EditDocument from '@main/dashboard/EditDocument';
import SideMenu from '@main/dashboard/SideMenu';
import ButtonSelect from '@shared/input/ButtonSelect';
import Manager from '@shared/modal/Manager';
import { useActionsByDocumentId, useDocuments, useUpdateDocument } from '@data/document/documentActions';
import { useGrids } from '@data/grid/gridActions';
import { useCreateWidget, useUpdateWidget, useWidgets } from '@data/widgets/widgetActions';
import { widgetTypeMeta } from '@util/enums';
import { parseWidgetConfig } from '@data/widgets/widgetConfig';
import { Lock, Unlock } from '@shared/icons/icons';
import { GridLockButton } from '@styled/Widget';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import ChartEditor from './chart/ChartEditor';
import KPIEditor from './kpi/KPIEditor';
import SingleValueEditor from './singleValue/SingleValueEditor';
import TagSlicerEditor from './tagSlicer/TagSlicerEditor';
import TimelineSlicerEditor from './timelineSlicer/TimelineSlicerEditor';
import { useAuth } from '../../providers/AuthProvider';
export function Dashboard() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var L = useLanguage().L;
    var _j = useAuth(); // needed for refreshing width when opening/closing sidebar
    var params = useParams();
    var dashGridWrapperRef = useRef(null);
    var selectedDocumentId = Number(params.selectedDocumentId);
    var documents = useDocuments();
    var currentReport = selectedDocumentId
        ? (_b = (_a = documents.data) === null || _a === void 0 ? void 0 : _a.find(function (d) { return d.id === selectedDocumentId; })) !== null && _b !== void 0 ? _b : null
        : null;
    var grids = useGrids();
    var currentGrid = (_c = grids.data) === null || _c === void 0 ? void 0 : _c.find(function (g) { return g.DocumentId === (currentReport === null || currentReport === void 0 ? void 0 : currentReport.id); });
    var documentActionsMap = useActionsByDocumentId();
    var createWidget = useCreateWidget();
    var updateDocument = useUpdateDocument();
    var widgetsQuery = useWidgets();
    var updateWidget = useUpdateWidget();
    var _k = __read(useState([]), 2), widgets = _k[0], setWidgets = _k[1];
    useEffect(function () {
        var _a;
        if (widgetsQuery.data && (currentGrid === null || currentGrid === void 0 ? void 0 : currentGrid.id)) {
            var thisReportWidgets = (_a = widgetsQuery.data) === null || _a === void 0 ? void 0 : _a.filter(function (w) { return w.GridId === currentGrid.id; });
            setWidgets(thisReportWidgets);
        }
    }, [widgetsQuery.data, currentGrid === null || currentGrid === void 0 ? void 0 : currentGrid.id]);
    var _l = __read(useState({}), 2), tagSlicersTagIdsLocalChanges = _l[0], setTagSlicersTagIdsLocalChanges = _l[1];
    var tagSlicersTagIdsLocalChangesHandler = function (tagSlicerId, tagIds, sameAsOriginal) {
        var newTagSlicersTagIdsLocalChanges = __assign({}, tagSlicersTagIdsLocalChanges);
        if (sameAsOriginal) {
            delete newTagSlicersTagIdsLocalChanges[tagSlicerId];
        }
        else {
            newTagSlicersTagIdsLocalChanges[tagSlicerId] = tagIds;
        }
        setTagSlicersTagIdsLocalChanges(newTagSlicersTagIdsLocalChanges);
    };
    useEffect(function () {
        setTagSlicersTagIdsLocalChanges({});
    }, [currentGrid === null || currentGrid === void 0 ? void 0 : currentGrid.id]);
    var saveSlicer = function (id) { return __awaiter(_this, void 0, void 0, function () {
        var w, newTagSlicersTagIdsLocalChanges, newActiveTagIds, widgetConfig, widgetCopyConfig, widgetCopy;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    w = widgets.find(function (w) { return w.id === id; });
                    if (!w) {
                        return [2 /*return*/];
                    }
                    newTagSlicersTagIdsLocalChanges = __assign({}, tagSlicersTagIdsLocalChanges);
                    newActiveTagIds = tagSlicersTagIdsLocalChanges[w.id];
                    if (!(w.type === WidgetType.TAGSLICER && newActiveTagIds)) return [3 /*break*/, 2];
                    widgetConfig = parseWidgetConfig(w.config, WidgetType.TAGSLICER);
                    widgetCopyConfig = __assign({}, widgetConfig);
                    widgetCopyConfig.tags = newActiveTagIds;
                    widgetCopy = __assign(__assign({}, w), { config: JSON.stringify(widgetCopyConfig) });
                    return [4 /*yield*/, updateWidget.mutateAsync(widgetCopy)];
                case 1:
                    _a.sent();
                    toast.success(L('Slicer state saved for everyone!'));
                    _a.label = 2;
                case 2:
                    delete newTagSlicersTagIdsLocalChanges[id];
                    setTagSlicersTagIdsLocalChanges(newTagSlicersTagIdsLocalChanges);
                    return [2 /*return*/];
            }
        });
    }); };
    var gridLocked = currentReport ? currentReport.gridLocked : true;
    var setGridLocked = function (value) {
        if (currentReport) {
            updateDocument.mutate(__assign(__assign({}, currentReport), { gridLocked: value }));
        }
    };
    var targetActions = (currentReport === null || currentReport === void 0 ? void 0 : currentReport.id) ? (_d = documentActionsMap.data) === null || _d === void 0 ? void 0 : _d[currentReport.id] : undefined;
    // Check if doc has slicer widget
    var hasSlicer = false;
    if (currentGrid !== undefined && widgets !== undefined) {
        hasSlicer = widgets.find(function (w) { return w.type === WidgetType.SLICER; }) !== undefined;
    }
    //Add tile/folder/report handlers
    function addTileHandler(type) {
        if (!currentGrid) {
            console.warn('Trying to create widget with no grid selected.');
            return;
        }
        switch (type) {
            case WidgetType.CHART:
                Manager.renderModal(React.createElement(ChartEditor, { gridId: currentGrid.id }));
                break;
            case WidgetType.KPI:
                Manager.renderModal(React.createElement(KPIEditor, { gridId: currentGrid.id }));
                break;
            case WidgetType.SINGLEVALUE:
                Manager.renderModal(React.createElement(SingleValueEditor, { gridId: currentGrid.id }));
                break;
            case WidgetType.TAGSLICER:
                Manager.renderModal(React.createElement(TagSlicerEditor, { gridId: currentGrid.id }));
                break;
            case WidgetType.SLICER:
                Manager.renderModal(React.createElement(TimelineSlicerEditor, { gridId: currentGrid.id }));
                break;
            case WidgetType.TEXTTILE:
                createWidget.mutate({ title: 'text', GridId: currentGrid.id, type: WidgetType.TEXTTILE });
                break;
            case WidgetType.PIVOT:
                createWidget.mutate({ title: '', GridId: currentGrid.id, type: WidgetType.PIVOT });
                break;
            default:
                console.warn("Trying to create widget of unkown type: ".concat(WidgetType[type]));
        }
    }
    function addDocumentHandler(type) {
        return function addHandler() {
            // documentstodo - fix showing subfolders, remove type check for folder
            var defaultParentId = type === DocumentType.FOLDER ? null : currentReport ? currentReport.ParentId : null;
            Manager.renderModal(React.createElement(EditDocument, { type: type, ParentId: defaultParentId }));
        };
    }
    //Render grid or message screen
    var content = currentGrid ? (React.createElement(DashGrid, { key: currentGrid === null || currentGrid === void 0 ? void 0 : currentGrid.id, grid: currentGrid, gridLocked: gridLocked, width: (_f = (_e = dashGridWrapperRef.current) === null || _e === void 0 ? void 0 : _e.getBoundingClientRect().width) !== null && _f !== void 0 ? _f : 0, documentActions: targetActions, saveSlicer: saveSlicer, tagSlicersTagIdsLocalChanges: tagSlicersTagIdsLocalChanges, tagSlicersTagIdsLocalChangesHandler: tagSlicersTagIdsLocalChangesHandler })) : (React.createElement("div", { className: "message-screen" }, documents.isLoading ? (React.createElement(AiOutlineLoading, { color: "grey", size: 33, style: {
            alignSelf: 'center',
            animation: 'spinicon 1s linear infinite',
        } })) : (React.createElement("h3", null, ((_g = documents.data) === null || _g === void 0 ? void 0 : _g.length)
        ? L('Select a report')
        : L('Create a new folder and start building reports.')))));
    var dashTitle;
    if (currentReport) {
        var parent = (_h = documents.data) === null || _h === void 0 ? void 0 : _h.find(function (doc) { return doc.id === currentReport.ParentId; });
        dashTitle = parent ? "".concat(parent.title, " / ").concat(currentReport.title) : currentReport.title;
    }
    var newTileOptions = widgetTypeMeta
        .filter(function (ptm) { return !hasSlicer || ptm.value !== WidgetType.SLICER; })
        .map(function (ptm) { return ({ label: L(ptm.label), value: ptm.value }); });
    return (React.createElement("div", { className: "container-fluid new-dash" },
        React.createElement(SideMenu, { onFolderAdd: addDocumentHandler(DocumentType.FOLDER), onReportAdd: addDocumentHandler(DocumentType.REPORT), currentReport: currentReport }),
        React.createElement("div", { className: "dashboard-container" },
            React.createElement("div", { className: "report-header", ref: dashGridWrapperRef },
                React.createElement("h3", { className: "title" },
                    dashTitle,
                    currentReport ? (React.createElement(GridLockButton, { onClick: function () { return setGridLocked(!gridLocked); } }, gridLocked ? React.createElement(Lock, null) : React.createElement(Unlock, null))) : null),
                React.createElement("div", { className: "header-buttons" },
                    React.createElement(ButtonSelect, { icon: FaPlus, title: L('Add Tile'), disabled: !((targetActions === null || targetActions === void 0 ? void 0 : targetActions.canUpdate) || (targetActions === null || targetActions === void 0 ? void 0 : targetActions.isOwner)) || !currentGrid, options: newTileOptions, onOption: function (tileOption) { return addTileHandler(tileOption.value); } }))),
            content)));
}
